export interface MoonPhase {
  name: string;
  icon: string;
  type: 'nuova' | 'crescente' | 'piena' | 'calante';
  percentage: number;
}

export function getMoonPhase(date: Date = new Date()): MoonPhase {
  // Algoritmo semplificato per calcolare la fase lunare
  // Basato sul ciclo sinodico di 29.53 giorni
  
  // Data di riferimento: Luna Nuova del 6 gennaio 2000
  const referenceDate = new Date(2000, 0, 6, 18, 14);
  const synodicMonth = 29.53058867; // giorni
  
  const timeDiff = date.getTime() - referenceDate.getTime();
  const daysDiff = timeDiff / (1000 * 60 * 60 * 24);
  const phase = ((daysDiff % synodicMonth) / synodicMonth + 1) % 1;
  
  // Determina la fase
  if (phase < 0.0625 || phase >= 0.9375) {
    return { name: 'Luna Nuova', icon: '🌑', type: 'nuova', percentage: 0 };
  }
  if (phase < 0.1875) {
    return { name: 'Luna Crescente', icon: '🌒', type: 'crescente', percentage: 10 };
  }
  if (phase < 0.3125) {
    return { name: 'Primo Quarto', icon: '🌓', type: 'crescente', percentage: 25 };
  }
  if (phase < 0.4375) {
    return { name: 'Gibbosa Crescente', icon: '🌔', type: 'crescente', percentage: 40 };
  }
  if (phase < 0.5625) {
    return { name: 'Luna Piena', icon: '🌕', type: 'piena', percentage: 50 };
  }
  if (phase < 0.6875) {
    return { name: 'Gibbosa Calante', icon: '🌖', type: 'calante', percentage: 60 };
  }
  if (phase < 0.8125) {
    return { name: 'Ultimo Quarto', icon: '🌗', type: 'calante', percentage: 75 };
  }
  return { name: 'Luna Calante', icon: '🌘', type: 'calante', percentage: 90 };
}

export function getMoonPhasesForMonth(year: number, month: number): MoonPhase[] {
  const phases: MoonPhase[] = [];
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  
  for (let day = 1; day <= daysInMonth; day++) {
    const date = new Date(year, month, day);
    phases.push(getMoonPhase(date));
  }
  
  return phases;
}
